import haDateFactory from 'ha/helpers/hadate';
import UrlResolver from 'ha/helpers/UrlResolver';
import createTranslateFunction from './createTranslateFunction';
import { IntlConfig, IntlObject } from './types';
import getMomentLocale from './getMomentLocale';

export default function createIntl({
  lang,
  baseDomain,
  messages,
}: IntlConfig): IntlObject {
  const locale = getMomentLocale(lang);
  const haDate = haDateFactory(locale);

  return {
    lang,
    locale,
    messages,
    T: createTranslateFunction(messages),
    urlResolver: UrlResolver.create({
      baseDomain,
      lang,
    }),
    formatDate: haDate.formatDate,
    fromNow: haDate.fromNow,
    toLocalizedString: haDate.toLocalizedString,
  };
}
